module.exports = __webpack_public_path__ + "img/close-circle-outline.96b54d54.svg";